import StringHelper from "../lib/string-helper";

export class GlobalService {
    constructor() {
        this.saveUTMTags();
    }

    saveUTMTags() {
        const utmTagKeys = ['source', 'campaign', 'medium', 'term', 'content'];
        const urlQueryParams = new URLSearchParams(window.location.search);

        for (const utmTagKey of utmTagKeys) {
            const utmTagValueFromQuery = urlQueryParams.get(`utm_${utmTagKey}`);

            if (!utmTagValueFromQuery) {
                continue;
            }

            const utmTagJsonDataFromStorage = localStorage.getItem(`utm${StringHelper.capitalize(utmTagKey)}`);
            const utmTagDataFromStorage = utmTagJsonDataFromStorage ? JSON.parse(utmTagJsonDataFromStorage) : null;

            if (utmTagDataFromStorage && typeof utmTagDataFromStorage === 'object' && utmTagDataFromStorage.value === utmTagValueFromQuery) {
                continue;
            }

            localStorage.setItem(`utm${StringHelper.capitalize(utmTagKey)}`, JSON.stringify({
                value: utmTagValueFromQuery,
                date: Date.now()
            }));
        }
    }
}